import { FormikProps, FormikValues } from 'formik'
import { ObjectSchema } from 'yup'

import { defaultRenderForm } from './components/Report/components/report-not-found'
import * as ReportR1 from './components/Report/components/r-1/components/form-fields'
import * as ReportR2 from './components/Report/components/r-2/components/form-fields'
import * as ReportR3 from './components/Report/components/r-3/components/form-fields'
import * as ReportR4 from './components/Report/components/r-4/components/form-fields'
import * as ReportR5 from './components/Report/components/r-5/components/form-fields'
import * as ReportR6 from './components/Report/components/r-6/components/form-fields'
import * as ReportR7 from './components/Report/components/r-7/components/form-fields'
import * as ReportR8 from './components/Report/components/r-8/components/form-fields'
import * as ReportR9 from './components/Report/components/r-9/components/form-fields'
import * as ReportR10 from './components/Report/components/r-10/components/form-fields'
import * as ReportR11 from './components/Report/components/r-11/components/form-fields'
import * as ReportR12 from './components/Report/components/r-12/components/form-fields'
import * as ReportR13 from './components/Report/components/r-13/components/form-fields'
import * as ReportR14 from './components/Report/components/r-14/components/form-fields'
import * as ReportR15 from './components/Report/components/r-15/components/form-fields'

interface GetReportParamsProps {
  render: (formikProps: FormikProps<FormikValues>) => JSX.Element
  initialValues: { [key: string]: any }
  validationSchema: ObjectSchema
}

function getInitialValues(report_class: string) {
  switch (report_class) {
    case 'R1':
      return ReportR1.getInitialValues()
    case 'R2':
      return ReportR2.getInitialValues()
    case 'R3':
      return ReportR3.getInitialValues()
    case 'R4':
      return ReportR4.getInitialValues()
    case 'R5':
      return ReportR5.getInitialValues()
    case 'R6':
      return ReportR6.getInitialValues()
    case 'R7':
      return ReportR7.getInitialValues()
    case 'R8':
      return ReportR8.getInitialValues()
    case 'R9':
      return ReportR9.getInitialValues()
    case 'R10':
      return ReportR10.getInitialValues()
    case 'R11':
      return ReportR11.getInitialValues()
    case 'R12':
      return ReportR12.getInitialValues()
    case 'R13':
      return ReportR13.getInitialValues()
    case 'R14':
      return ReportR14.getInitialValues()
    case 'R15':
      return ReportR15.getInitialValues()
    default:
      return {}
  }
}

function useGetRender(report_class: string) {
  switch (report_class) {
    case 'R1':
      return ReportR1.getRenderForm()
    case 'R2':
      return ReportR2.getRenderForm()
    case 'R3':
      return ReportR3.getRenderForm()
    case 'R4':
      return ReportR4.getRenderForm()
    case 'R5':
      return ReportR5.getRenderForm()
    case 'R6':
      return ReportR6.getRenderForm()
    case 'R7':
      return ReportR7.getRenderForm()
    case 'R8':
      return ReportR8.getRenderForm()
    case 'R9':
      return ReportR9.getRenderForm()
    case 'R10':
      return ReportR10.getRenderForm()
    case 'R11':
      return ReportR11.getRenderForm()
    case 'R12':
      return ReportR12.getRenderForm()
    case 'R13':
      return ReportR13.getRenderForm()
    case 'R14':
      return ReportR14.getRenderForm()
    case 'R15':
      return ReportR15.getRenderForm()
    default:
      return defaultRenderForm
  }
}

function getValidationSchema(report_class: string) {
  switch (report_class) {
    case 'R1':
      return ReportR1.getValidationSchema()
    case 'R2':
      return ReportR2.getValidationSchema()
    case 'R3':
      return ReportR3.getValidationSchema()
    case 'R4':
      return ReportR4.getValidationSchema()
    case 'R5':
      return ReportR5.getValidationSchema()
    case 'R6':
      return ReportR6.getValidationSchema()
    case 'R7':
      return ReportR7.getValidationSchema()
    case 'R8':
      return ReportR8.getValidationSchema()
    case 'R9':
      return ReportR9.getValidationSchema()
    case 'R10':
      return ReportR10.getValidationSchema()
    case 'R11':
      return ReportR11.getValidationSchema()
    case 'R12':
      return ReportR12.getValidationSchema()
    case 'R13':
      return ReportR13.getValidationSchema()
    case 'R14':
      return ReportR14.getValidationSchema()
    case 'R15':
      return ReportR15.getValidationSchema()
    default:
      return null
  }
}

function useGetReportParams(report_class: string): GetReportParamsProps {
  return {
    initialValues: getInitialValues(report_class),
    render: useGetRender(report_class),
    validationSchema: getValidationSchema(report_class)
  }
}

export default useGetReportParams
